import React from 'react';
import { useField } from 'informed';
import { useTranslation } from 'react-i18next';

import { FileUploaderField } from '../FileUploaderField';

import { FieldContainer } from './styledComponents';

export interface InformedFileUploaderFieldTypes {
  field: string;
  isHidden: boolean;
  isDisabled: boolean;
  fieldContainerStyles?: React.CSSProperties;
  error: any;
  touched: any;
  label: string;
  validationSchema: any;
  fileUploader;
  overrideBucketPath?: string;
  extraBucketPath?: string;
  getCustomFileName: any;
  helperText?: string;
  shouldShowDeleteButton?: boolean;
  labelTextCSS?: React.CSSProperties;
  styledHintClassName?: string;
  onFileUpload?: (file: string) => void;
}

export const InformedFileUploaderField = (
  props: InformedFileUploaderFieldTypes
) => {
  const {
    field,
    isHidden,
    isDisabled,
    error,
    touched,
    label,
    validationSchema,
    fileUploader,
    overrideBucketPath,
    extraBucketPath,
    getCustomFileName,
    helperText,
    fieldContainerStyles,
    shouldShowDeleteButton,
    labelTextCSS,
    styledHintClassName,
    onFileUpload
  } = props;
  const { t } = useTranslation();

  const { render, fieldApi, informed, fieldState } = useField({
    field,
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: validationSchema.fields[field],
    error: error,
    touched: touched,
    isDisabled,
    label
  });
  const { value } = fieldState;
  const { setValue } = fieldApi;
  const { onBlur } = informed;

  const onDeleteSuccess = () => {
    setValue('');
  };

  return render(
    <FieldContainer css={fieldContainerStyles} isHidden={isHidden} key={field}>
      <FileUploaderField
        value={value as string}
        field={field}
        label={label}
        setFieldValue={(value) => {
          setValue(value);
          onFileUpload && onFileUpload(value);
        }}
        isDisabled={isDisabled}
        handleBlur={onBlur}
        error={error}
        touched={touched}
        overrideBucketPath={overrideBucketPath}
        extraBucketPath={extraBucketPath}
        t={t}
        fileUploader={fileUploader}
        getCustomFileName={getCustomFileName}
        onDeleteSuccess={onDeleteSuccess}
        helperText={helperText}
        shouldShowDeleteButton={shouldShowDeleteButton}
        labelTextCSS={labelTextCSS}
        styledHintClassName={styledHintClassName}
      />
    </FieldContainer>
  );
};
